import React, { useState } from 'react';
import SarasTrans from '../../../library/notifications/SarasTrans';
import DocSearch from "../../cmn/docSearch/components/DocSearch";
import ActionButton from '../../../library/input/buttons/button/SarasButton';

const InsightsCriteria = (props) => {
    const { viewData, report, onCriteriaApply, onCriteriaClose } = props;
    const [insightCriteria, setInsightCriteria] = useState(null);

    // console.log("criteriaValue", viewData);

    const onChange = (reload, criteriaValue) => {
        // console.log("criteriaValue", criteriaValue);
        
        setInsightCriteria(criteriaValue);
    }
    
    const onApplyClicked = () => {

        if(onCriteriaApply) onCriteriaApply(insightCriteria);
    }

    const onCancelClicked = () => {

        if(onCriteriaClose) onCriteriaClose();
    }

    if (!viewData)
        return(<div> </div>);

    if(Object.values(viewData.childViews).length <= 0)
        return(<div> </div>);

    return (
        <div className={`uiInsightView ${viewData.ViewOptions?.viewContainerClass || 'uiInsightViewWhite'}`}>
            <div className="uiInsightViewAction">
                <div className='uiInsightViewActionContainer uiFlexBox'>
                    <div className='uiInsightViewActionLeft uiFlexBox'>
                        <span className='uiInsightCriteriaEditor uiInsightTitle'>
                            <SarasTrans value="Edit Filter" />
                        </span>
                    </div>
                    <div className='uiInsightViewActionRight uiFlexBox'>
                        <ActionButton onClick={onApplyClicked} text="Apply Filter" icon="applyChanges" 
                                tooltip="Apply new criteria"
                                className=""/>
                        <ActionButton onClick={onCancelClicked} text="Cancel Changes" icon="cancelChanges" 
                                tooltip="Cancel changing criteria"
                                className="uiSecondaryAction"/>
                    </div>
                </div>
            </div>

            <div className="uiInsightViewContent">
                <div className="uiInsightDynamicViewWrapper" style={{ height: 'calc(100% - 40px)'}}>
                    <DocSearch viewData={viewData} onSearchByCriteria={onChange} rptKey={report} actionName="coreMIS" 
                        enableSearch={false} enableGroups={false} enablefav={false} 
                    />
                </div>
            </div>
        </div>
    )
}

export default InsightsCriteria
